import React from 'react';
import { Link } from 'react-router-dom';

// import utils
import { setBodyBackgroudColor } from 'js/utils/general';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';
import SectionPageWrapper from 'js/containers/section/Section.page-wrapper';

import TransitionPage from 'js/containers/transition/Transition.page';

const PageNotFound = () => {
  React.useEffect(() => {
    setBodyBackgroudColor('#F7EBB1');
  }, []);
  return (
    <TransitionPage>
      <SiteMetaData />
      <SectionPageWrapper className="page--library" bgColor="#F7EBB1">
        <div className="page page--page-not-found">
          <div className="container">
            <Link to={'/'}>Click to homepage</Link>
          </div>
        </div>
      </SectionPageWrapper>
    </TransitionPage>
  );
};

export default PageNotFound;
